import {
  Button,
  Colors,
  Cross,
  ExplainerIcon,
  ExplainerIconIcon,
  Modal,
  Typography
} from '@giantleap/components-library'
import { supportEmail } from 'config'
import * as React from 'react'
import { _route } from '../../routes/config'
import styles from './style.module.scss'

interface IProps {
  open: boolean
  onClose: () => void
  onSubmit: () => void
  isPlusUser: boolean
  goToPlus: () => void
  isEvaluationCompletedOpen: boolean
}

interface IState {}

export class NewScoreModal extends React.Component<IProps, IState> {
  onBackBrowserBtnEvent = event => {
    event.preventDefault()

    const { onClose } = this.props
    onClose()

    window.removeEventListener('popstate', this.onBackBrowserBtnEvent)
  }

  componentDidMount() {
    window.history.pushState(null, '', window.location.pathname)
    window.addEventListener('popstate', this.onBackBrowserBtnEvent)
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.onBackBrowserBtnEvent)
  }

  setActive = (status: boolean) => {
    if (!status) {
      const { onClose } = this.props
      window.removeEventListener('popstate', this.onBackBrowserBtnEvent)
      onClose()
    }
  }

  render() {
    const {
      open,
      onSubmit,
      isPlusUser,
      goToPlus,
      isEvaluationCompletedOpen
    } = this.props

    return (
      <Modal
        x={<Cross color={Colors.unselected} size="big" />}
        active={open}
        setActive={this.setActive}
        baseClassName={styles.wrap}
      >
        <Typography
          type="title"
          size="big"
          className={styles['negative-margin']}
        >
          {isEvaluationCompletedOpen
            ? 'Evaluation Complete'
            : 'New score available'}
          <span style={{ color: Colors.redAccent }}>!</span>
        </Typography>
        {isPlusUser ? (
          <Typography type="text" className={styles['negative-margin']}>
            We would{' '}
            <span style={{ color: Colors.redAccent, cursor: 'pointer' }}>
              love
            </span>{' '}
            to get your feedback,
            <br />
            email us at{' '}
            <a
              style={{ color: '#0085FF', textDecoration: 'none' }}
              href={`mailto:${supportEmail}?subject=GiantLeap%20Feedback`}
            >
              support@giantleap.tech
            </a>
          </Typography>
        ) : (
          <Typography type="text">
            Some scores are only visible to{' '}
            <span
              style={{ color: Colors.redAccent, cursor: 'pointer' }}
              onClick={() => goToPlus()}
            >
              Plus
            </span>{' '}
            users.{' '}
            <span
              style={{ color: Colors.redAccent, cursor: 'pointer' }}
              onClick={() => goToPlus()}
            >
              Upgrade now
            </span>{' '}
            to unlock all the scores in your child’s abilities map
          </Typography>
        )}
        <ExplainerIcon icon={<ExplainerIconIcon type="boy" />} />
        <Button
          onClick={() => {
            window.removeEventListener('popstate', this.onBackBrowserBtnEvent)
            onSubmit()
          }}
          type="max"
          color="pink"
        >
          View Abilities Map
        </Button>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/NewScoreModal/index.tsx